import { ReactNode } from 'react'

import { withdrawValidationIssueToMessage } from '../logic/form/validation'
import { getChainConfigEntry } from '@/config/chain'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { links } from '@/ui/constants/links'
import { Info } from '@/ui/molecules/info/Info'

interface WithdrawValidationErrorProps {
  message?: string
  'data-testid'?: string
  chainId: number
}

export function WithdrawValidationError({
  message,
  chainId,
  'data-testid': dataTestId,
}: WithdrawValidationErrorProps): ReactNode {
  if (!message) {
    return null
  }

  const chainName = getChainConfigEntry(chainId).meta.name

  return (
    <div data-testid={dataTestId} className="typography-label-4 text-system-error-primary">
      {(() => {
        switch (message) {
          case 'value-not-positive':
          case 'exceeds-balance':
            return withdrawValidationIssueToMessage[message]
          case 'usds-withdraw-cap-reached':
          case 'usdc-withdraw-cap-reached':
          case 'savings-v2-not-enough-liquidity':
            return (
              <>
                This withdrawal exceeds the current available liquidity on {chainName}, please try a smaller amount.{' '}
                <br className="hidden sm:block" />
                The Spark Liquidity Layer will refill the reserve shortly after.{' '}
                <Info className="inline">
                  For more information see Spark Liquidity Layer{' '}
                  <ExternalLink to={links.docs.sparkLiquidityLayer} variant="secondary">
                    docs
                  </ExternalLink>
                  .
                </Info>
              </>
            )
          default:
            return message
        }
      })()}
    </div>
  )
}
